import { render, staticRenderFns } from "./DialogBox.vue?vue&type=template&id=cc987306&scoped=true&"
import script from "./DialogBox.vue?vue&type=script&lang=ts&"
export * from "./DialogBox.vue?vue&type=script&lang=ts&"
import style0 from "./DialogBox.vue?vue&type=style&index=0&id=cc987306&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc987306",
  null
  
)

export default component.exports